/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { ApiQuery, ApiQuerySortTypes } from '@app/core/http/api-query';
import { Type } from '@app/settings/types/types.model';
import { TypesService } from '@app/settings/types/types.service';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';

@Component({
  selector: 'app-type-select',
  templateUrl: './type-select.component.html',
  styleUrls: ['./type-select.component.scss'],
})
export class TypeSelectComponent implements OnInit {
  data: Array<Type>;
  apiQuery: ApiQuery = new ApiQuery();
  loader: boolean;

  @Input() selectedType: Type;
  @Input() parentFormGroup: FormGroup;
  @Input() groupType: string = null;
  @Input() passFormControlName = 'value';
  @Input() bindValue = 'id';
  @Input() model: any = 'undefined';
  @Input() selectFirst = false;
  @Input() onlyActive = true;
  @Input() readonly = false;
  @Input() clearable = true;
  @Input() isInModal = true;

  @Output() modelChange: EventEmitter<number | null> = new EventEmitter<number | null>();
  @Output() select = new EventEmitter();

  @Output() modelItemChange: EventEmitter<Type | null> = new EventEmitter<Type | null>();

  input$ = new Subject<string>();

  constructor(private typeService: TypesService) {}

  ngOnInit(): void {
    this.loadTypes();

    if (this.model === 'undefined' && this.selectedType) {
      this.data = [this.selectedType];
      this.parentFormGroup.patchValue({ type: this.selectedType.id });
    }
  }

  loadTypes(): void {
    if (this.onlyActive) {
      this.apiQuery.addFilter('active', true);
    }

    this.apiQuery.setSort('order_index', ApiQuerySortTypes.ASC);

    this.typeService
      .index(
        this.apiQuery
          .addFilters({
            type: this.groupType,
          })
          .setLimit(9999)
      )
      .subscribe((response: PaginatedResponse) => {
        this.data = response.data;
        this.loader = false;

        if (
          this.selectFirst &&
          this.model === 'undefined' &&
          !this.parentFormGroup.get(this.passFormControlName).value
        ) {
          this.parentFormGroup.get(this.passFormControlName).patchValue(response.data[0].id);
        }

        if (this.selectFirst && this.model !== 'undefined') {
          this.model = response.data[0].id;
          this.modelChange.emit(response.data[0].id);
          this.select.emit(response.data[0]);
        }
      });
  }

  onChange(type: any): void {
    this.select.emit(type);
  }

  changeModel(event: Type | null): void {
    this.modelItemChange.emit(event || null);
    this.modelChange.emit(event?.id || null);
  }
}
